import {apiClient} from "@/lib/api-client";
import type {components} from "@/lib/api-types";

export type Post = components["schemas"]["PostResponse"];
export type Suggestion = components["schemas"]["SuggestedAction"];
export type LaunchRequest = components["schemas"]["LaunchRequest"];
export type LaunchResponse = components["schemas"]["LaunchResponse"];
export type SuggestionsResponse = components["schemas"]["SuggestionsResponse"];

// Influence Map types
export type InfluenceGraphNode = components["schemas"]["GraphNode"];
export type InfluenceGraphLink = components["schemas"]["GraphLink"];
export type InfluenceLinkComment = components["schemas"]["LinkComment"];
export type InfluenceGraphResponse =
  components["schemas"]["app__schemas__influence_map__InfluenceGraphResponse"];
export type DataSource = components["schemas"]["DataSource"];

export async function fetchPost(postId: string): Promise<Post> {
  const {data, error} = await apiClient.GET("/api/influence/post/{post_id}", {
    params: {path: {post_id: postId}},
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to fetch post");
  }

  return data;
}

export async function fetchSuggestions(postId: string): Promise<SuggestionsResponse> {
  const {data, error} = await apiClient.GET("/api/influence/suggested", {
    params: {query: {post_id: postId}},
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to fetch suggestions");
  }

  return data;
}

export async function launchBots(request: LaunchRequest): Promise<LaunchResponse> {
  const {data, error} = await apiClient.POST("/api/influence/launch", {
    body: request,
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to launch bots");
  }

  return data;
}

export async function fetchInfluenceGraph(source: DataSource): Promise<InfluenceGraphResponse> {
  const {data, error} = await apiClient.GET("/api/influence-map/graph", {
    params: {query: {source}},
  });

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to fetch influence graph");
  }

  return data;
}
